module.exports = __webpack_public_path__ + "img/vid_4_splash.e9242334.jpg";